import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import Reveal from "../Reveal";
import { MANIFESTO, PHOTOS } from "../../lib/site";

const IMGS = [PHOTOS.crewMohali150, PHOTOS.resChd20, PHOTOS.carportKharar100, PHOTOS.resMohali10];

function Row({ item, img, i }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [60, -60]);
  return (
    <div ref={ref} className="grid items-center gap-8 border-t border-line py-14 md:grid-cols-2 md:gap-16 md:py-20">
      <div className={i % 2 === 1 ? "md:order-2" : ""}>
        <Reveal>
          <span className="font-mono text-6xl font-bold text-gold md:text-8xl">{item.n}</span>
          <h3 className="mt-4 font-heading text-3xl font-bold text-forest md:text-4xl">{item.title}</h3>
          <p className="mt-4 max-w-md text-base leading-relaxed text-moss md:text-lg">{item.body}</p>
        </Reveal>
      </div>
      <div className={`relative h-64 overflow-hidden rounded-3xl md:h-80 ${i % 2 === 1 ? "md:order-1" : ""}`}>
        <motion.img style={{ y }} src={img} alt={item.title} className="absolute inset-0 h-[130%] w-full object-cover" />
        <div className="absolute inset-0 bg-forest/10 mix-blend-multiply" />
      </div>
    </div>
  );
}

export default function Manifesto() {
  return (
    <section id="how" data-testid="manifesto" className="bg-cream py-24 md:py-32">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <Reveal className="mb-8 max-w-2xl">
          <p className="text-xs uppercase tracking-[0.25em] text-gold">How we work</p>
          <h2 className="mt-4 font-heading text-4xl font-extrabold tracking-tight text-forest md:text-5xl">
            From sunlight to savings, in four simple steps.
          </h2>
        </Reveal>
        {MANIFESTO.map((item, i) => <Row key={item.n} item={item} img={IMGS[i]} i={i} />)}
      </div>
    </section>
  );
}
